"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseLogger = void 0;
var BaseLogger = (function () {
    function BaseLogger() {
    }
    BaseLogger.prototype.initHandler = function (config, initCallback) {
        try {
            if (!config) {
                var message = "Logger class requires configurations to be passed into constructor" +
                    ", during initialization. Please see the README for more information";
                var error = new Error(message);
                error.code = "HT_LOGGER_10001";
                throw error;
            }
            this.config = config;
            initCallback(config);
        }
        catch (error) {
            if (error) {
                error.code = error.code ? error.code : "HT_LOGGER_10000";
                var initError = "Initialization of \"Logger\" class Failed: ";
                error.message = error.message ? initError + error.message : initError;
            }
            throw error;
        }
    };
    return BaseLogger;
}());
exports.BaseLogger = BaseLogger;
